import BlurbListColumns from './BlurbList.Columns';
import BlurbListCarousel from './BlurbList.Carousel';
import BlurbListShowcase from './BlurbList.Showcase';
import BlurbListSlider from './BlurbList.Slider';
import BlurbListVertical from './BlurbList.Vertical';
import BlurbListMap from './BlurbList.Map';
import './_blurb-list.scss';

/**
 * BlurbList component using compound component pattern.
 * Provides different layout variants for displaying multiple Blurbs.
 *
 * @example
 *   <Blurb>...</Blurb>
 *   <Blurb>...</Blurb>
 *
 * @example
 * <BlurbList.Columns columns={3}>
 *   <Blurb>...</Blurb>
 *   <Blurb>...</Blurb>
 * </BlurbList.Columns>
 *
 * @example
 * <BlurbList.Carousel>
 *   <Blurb>...</Blurb>
 *   <Blurb>...</Blurb>
 * </BlurbList.Carousel>
 */
export default function BlurbList({ children, className = '' }) {
  return <div className={`BlurbList ${className}`}>{children}</div>;
}

BlurbList.Vertical = BlurbListVertical;
BlurbList.Columns = BlurbListColumns;
BlurbList.Carousel = BlurbListCarousel;
BlurbList.Showcase = BlurbListShowcase;
BlurbList.Slider = BlurbListSlider;
BlurbList.Map = BlurbListMap;
